import React from 'react';
import { Col, Row } from 'antd';

import styles from './index.module.scss';
import { MainLogo } from '../../../Common/Icon';

export interface WrapperProps {
  children: React.ReactNode
}

export default function Wrapper({ children }: WrapperProps): React.ReactNode {
  return (
    <Row justify="center">
      <Col className={styles.wrapper}>
        <MainLogo />

        <div className={styles.content}>
          {children}
        </div>
      </Col>
    </Row>
  );
}
